<template>
  <div>
    <div
      v-for="(item, index) in displayList"
      :key="index"
      class="flex justify-between my-2 text-sm"
      :class="{ [margin]: margin, 'items-start gap-3': item.type === 'addon-detail' }"
    >
      <template v-if="item.type === 'addons'">
        <div class="flex items-center min-w-0">
          <span data-test-id="price-details__price-item-description">{{ item.label }}</span>
          <button
            type="button"
            class="ml-1 flex items-center border-0 bg-transparent p-0 text-grey-800"
            aria-label="Add-on price details"
            data-test-id="price-details__addons-info"
            @click="activeAddonGroup = item"
          >
            <InfoIcon class="w-5 h-5" />
          </button>
        </div>
        <div class="flex items-center shrink-0 text-right">
          <span data-test-id="price-details__price-item-amount">
            {{ item.totalPrice?.formatted }}
          </span>
        </div>
      </template>
      <template v-else-if="item.type === 'addon-detail'">
        <div class="min-w-0 flex items-center">
          <span data-test-id="price-details__price-item-description">{{ item.label }}</span>
          <button
            v-if="item.addon"
            type="button"
            class="ml-1 inline-flex items-center align-middle border-0 bg-transparent p-0 text-grey-800"
            aria-label="Add-on details"
            data-test-id="price-details__addon-info"
            @click="activeAddon = item.addon"
          >
            <InfoIcon class="w-5 h-5" />
          </button>
        </div>
        <div class="flex flex-col-reverse items-end im:flex-row im:items-center gap-x-3 shrink-0">
          <span class="text-grey-600 whitespace-nowrap">{{ addonBreakdownLabel(item) }}</span>
          <span data-test-id="price-details__price-item-amount">
            {{ item.totalPrice.formatted }}
          </span>
        </div>
      </template>
      <template v-else-if="item?.totalPrice?.inCents !== 0">
        <div class="flex items-center min-w-0">
          <span data-test-id="price-details__price-item-description">{{ item.label }}</span>
          <CleaningFeeTooltip v-if="item.label === 'Cleaning fee'" />
          <button
            v-if="item.addon"
            type="button"
            class="ml-1 flex items-center border-0 bg-transparent p-0 text-grey-800"
            aria-label="Add-on details"
            data-test-id="price-details__addon-info"
            @click="activeAddon = item.addon"
          >
            <InfoIcon class="w-5 h-5" />
          </button>
        </div>
        <div class="flex items-center gap-3 shrink-0 text-right">
          <span v-if="item.unitPriceLabel" class="text-grey-600">{{ item.unitPriceLabel }}</span>
          <span v-if="item.quantity" class="text-grey-600">{{ item.quantity }}x</span>
          <span data-test-id="price-details__price-item-amount">
            {{ item.totalPrice.formatted }}
          </span>
        </div>
      </template>
    </div>

    <AddonInfoModal v-if="activeAddon" :addon="activeAddon" @close="activeAddon = null" />
    <AddonPriceDetailsModal v-if="activeAddonGroup" :group="activeAddonGroup" @close="activeAddonGroup = null" />
  </div>
</template>

<script>
import InfoIcon from '@tagvenue/icons/24/line/general/info-circle.svg';

import CleaningFeeTooltip from '@/components/Ui/CleaningFeeTooltip.vue';

import AddonInfoModal from './AddonInfoModal.vue';
import AddonPriceDetailsModal from './AddonPriceDetailsModal.vue';
import { resolveAddonUnit } from './resolveAddonUnit';

export default {
  components: { CleaningFeeTooltip, AddonInfoModal, AddonPriceDetailsModal, InfoIcon },
  props: {
    list: {
      type: Array,
      required: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    margin: String,
    expandAddons: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeAddon: null,
      activeAddonGroup: null,
    };
  },
  computed: {
    displayList() {
      if (!this.expandAddons) {
        return this.list;
      }

      return this.list.flatMap((item) => {
        if (item?.type !== 'addons') {
          return item;
        }

        return item.items.map((addon) => ({
          type: 'addon-detail',
          label: addon.label,
          quantity: addon.quantity,
          pricePerUnit: addon.pricePerUnit,
          totalPrice: addon.totalPrice,
          unit: resolveAddonUnit(addon.pricingUnit, addon.quantity),
        }));
      });
    },
  },
  methods: {
    addonBreakdownLabel(item) {
      const base = `${item.pricePerUnit.formatted} x ${item.quantity}`;
      return item.unit ? `(${base} ${item.unit})` : `(${base})`;
    },
  },
};
</script>

<style lang="scss">

</style>
